export const RESUME_PATH = "/resume/joshua-welford-resume.pdf"
export const VCARD_PATH = "/resume/joshua-welford.vcf"
export const SITE_ROUTES = [
  { to: "/", label: "Home", group: "Navigation", keywords: ["intro", "joshua", "welford"] },
  { to: "/music", label: "Music", group: "Navigation", keywords: ["listening", "music bot", "spotify"] },
  { to: "/activities", label: "Activities", group: "Navigation", keywords: ["presence", "discord", "live"] },
  { to: "/memories", label: "Memories", group: "Navigation", keywords: ["canvas", "collaboration", "board"] },
  { to: "/contact", label: "Contact", group: "Navigation", keywords: ["email", "work"] },
]

export const SKILL_NODES = [
  {
    id: "frontend",
    label: "Frontend",
    detail: "React, Gatsby, motion, interaction systems",
    evidence: [
      { label: "Home", to: "/" },
      { label: "Music UI", to: "/music" },
      { label: "Memories UI", to: "/memories" },
    ],
  },
  {
    id: "backend",
    label: "Backend/API",
    detail: "Cloudflare Pages Functions and typed service boundaries",
    evidence: [
      { label: "Booking API", to: "/" },
      { label: "Music API", to: "/music" },
      { label: "Activities API", to: "/activities" },
    ],
  },
  {
    id: "infra",
    label: "Infra",
    detail: "Workers, D1, R2, local/prod environment wiring",
    evidence: [
      { label: "Activities", to: "/activities" },
      { label: "Memories", to: "/memories" },
    ],
  },
  {
    id: "design-systems",
    label: "Design Systems",
    detail: "Liquid glass controls, trays, focusable compact UI",
    evidence: [
      { label: "Home CTA", to: "/" },
      { label: "Navigation", to: "/" },
      { label: "Music Chat", to: "/music" },
    ],
  },
  {
    id: "ai",
    label: "AI",
    detail: "Contextual assistants and bounded question answering",
    evidence: [
      { label: "Music Bot", to: "/music" },
      { label: "Ask Music", eventName: "wf:open-music-chat", fallbackPath: "/music" },
    ],
  },
  {
    id: "cloudflare",
    label: "Cloudflare",
    detail: "Pages Functions, Email, Turnstile, D1 and R2",
    evidence: [
      { label: "Booking", eventName: "wf:open-booking", fallbackPath: "/" },
      { label: "Activities", to: "/activities" },
      { label: "Memories", to: "/memories" },
    ],
  },
  {
    id: "music-data",
    label: "Music/Data",
    detail: "Listening-history search, ranking and natural-language answers",
    evidence: [
      { label: "Music Page", to: "/music" },
      { label: "Top Tracks", to: "/music" },
      { label: "Ask Music", eventName: "wf:open-music-chat", fallbackPath: "/music" },
    ],
  },
]

export const COMMANDS = [
  ...SITE_ROUTES.map(route => ({
    id: `route:${route.to}`,
    label: route.label,
    group: route.group,
    kind: "route",
    to: route.to,
    keywords: route.keywords,
  })),
  {
    id: "booking:start",
    label: "Start booking",
    group: "Work",
    kind: "event",
    eventName: "wf:open-booking",
    fallbackPath: "/",
    keywords: ["hire", "meeting", "calendar", "work together"],
  },
  {
    id: "resume:request",
    label: "Request CV",
    group: "Work",
    kind: "event",
    eventName: "wf:request-cv",
    keywords: ["cv", "resume", "pdf", "recruiter"],
  },
  {
    id: "contact:vcard",
    label: "Add to Contacts",
    group: "Work",
    kind: "download",
    href: VCARD_PATH,
    keywords: ["vcard", "vcf", "email"],
  },
  {
    id: "music:ask",
    label: "Ask music",
    group: "Experiments",
    kind: "event",
    eventName: "wf:open-music-chat",
    fallbackPath: "/music",
    keywords: ["music bot", "listening history", "ai"],
  },
]
